/**
 * Browser page translators (Chrome/Edge "Translate this page", extensions)
 * wrap React-managed text nodes in <font> tags. React's next commit then
 * calls insertBefore/removeChild with stale references and crashes the app
 * with "NotFoundError: Failed to execute 'insertBefore' on 'Node'".
 * Known upstream issue: https://github.com/facebook/react/issues/11538
 *
 * This patch degrades gracefully instead: skip the impossible DOM move and
 * let React recover on the next render. Must run before React mounts.
 */
export function patchDomForBrowserTranslate(): void {
  const originalRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      console.warn('removeChild skipped: node was moved by a page translator or extension')
      return child
    }
    return originalRemoveChild.call(this, child) as T
  }

  const originalInsertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function <T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.warn('insertBefore skipped: node was moved by a page translator or extension')
      return newNode
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T
  }
}
